const Client = require("../modules/ModHttpsClient")

module.exports = {
    data: {},
    create(data) {
        return new Promise(resolve => {
            Client.queryPost([
                {
                    key: "mode",
                    value: 3
                }
            ],
                data,
                {
                    path: "/participant/create"
                }).then(() => {
                    resolve(true)
                }).catch(() => {
                    resolve(false)
                })

        })
    }
}